module.exports = __webpack_public_path__ + "static/homepage-3-13-1ee46cbf0e3d4ac73a94fae25c4c611a.png";